const fulfillmentOrderAction = {
    BulkCancel: 0,
    LabelPullOnPickingBatchCreate: 1,
    BulkAssignCarrierAccount: 2
}

export { fulfillmentOrderAction };